






import { Vue, Prop, Component } from 'vue-property-decorator';
import QueueHome from '@/components/queuemanagement/QueueHome.vue';
import QueueBranches from '@/components/queuemanagement/QueueBranches.vue';
import QueueStatus from '@/components/queuemanagement/QueueStatus.vue';
import ComponentAction from '@/components/queuemanagement/ComponentActionInterface';

@Component({
  components: {
    QueueHome,
    QueueBranches,
    QueueStatus,
  },
})
export default class QueueManagement extends Vue {
  currentComponent: string = 'QueueHome';

  mounted() {
    if (this.$route.params && this.$route.params.type && this.$route.params.type === 'details') {
      this.currentComponent = 'QueueBranches';
    }
  }

  componentAction(val: ComponentAction): void {
    console.log(val);
    if (val.action === 'componentChange') {
      this.componentChange(val);
    }
  }

  componentChange(val: ComponentAction): void {
    this.currentComponent = `Queue${val.actionData}`;
  }
}
